<template lang="pug">
  .row
    .col-12
      header.mb-4
        h1#tittle {{$route.name}}
    .col-12
      b-card( border-variant="primary" header-bg-variant="primary" header-text-variant="white")
        template(v-slot:header)
          h5.text-white.m-0 Datos personales
        form(@submit.prevent="changePass")
          .row.d-flex.flex-wrap
            .form-group.col-md-6
              label Nombres
              input.form-control(type="text" disabled v-model="form.name"  )
            .form-group.col-md-6
              label Apellidos
              input.form-control(type="text" disabled v-model="form.lastname")
            .form-group.col-md-6
              label Rut
              input.form-control(type="text" disabled v-model="form.rut")
            .form-group.col-md-6
              label E-mail
              input.form-control(type="email" disabled v-model="form.email")
            .form-group.col-md-6
              label Contraseña
              input.form-control(:type="passwordVisible ? 'text' : 'password'" v-model="form.password")
            .form-group.col-md-6
              label Repita contraseña
              input.form-control(type="password" v-model="form.repeatPassword")
            .form-group.form-check.w-100.text-right.px-4
              input.form-check-input(type="checkbox" id="view-pass" @click='togglePasswordVisibility')
              label.form-check-label(for="view-pass") Ver contraseña
          .col-12.d-flex.justify-content-between.mb-5
            button.btn.button#buttonBack.px-5(@click="$router.push('/')") Volver
            button.btn.button#buttonSave.px-5(type="submit") Guardar
</template>

<script>
// @ is an alias to /src
import DefaultLayout from '@/layouts/DefaultLayout'
import { appisAmulenCore } from '../utils/axiosInstances'

export default {
  name: 'changePass',
  data () {
    return {
      apps: [
        { id: 'app-1', name: 'App 1' },
        { id: 'app-2', name: 'App 2' },
        { id: 'app-3', name: 'App 3' },
        { id: 'app-4', name: 'App 4' },
        { id: 'app-5', name: 'App 5' }
      ],
      form: {
        name: '',
        lastname: '',
        email: '',
        rut: '',
        id: '',
        password: '',
        repeatPassword: ''
      },
      passwordVisible: false,
      selected: [],
      allSelected: false,
      selectText: {
        text: 'Seleccionar todos'
      },
      appIds: []
    }
  },
  methods: {
    togglePasswordVisibility () {
      this.passwordVisible = !this.passwordVisible
    },
    selectAll: function () {
      this.appIds = []

      if (!this.allSelected) {
        for (this.app in this.apps) {
          this.appIds.push(this.apps[this.app].id.toString())
        }
      }
      this.selectText.text = this.allSelected ? 'Seleccionar todos' : 'Deseleccionar todos'
    },
    select: function () {
      this.allSelected = false
    },
    loadUserData () {
      this.form = {
        ...this.form,
        name: localStorage.getItem('name'),
        lastname: localStorage.getItem('lastname'),
        email: localStorage.getItem('email'),
        rut: localStorage.getItem('rut')
      }
    },
    async changePass () {
      if (this.form.password === this.form.repeatPassword) {
        await appisAmulenCore({
          method: 'put',
          url: '/user',
          data: {
            password: this.form.password,
            _id: localStorage.getItem('id')
          }
        })
        alert('Contraseña cambiada correctamente!')
      } else {
        alert('Las contraseñas no coinciden!')
      }
    }
  },
  created () {
    this.$emit('update:layout', DefaultLayout)
  },
  mounted () {
    this.loadUserData()
  }
}

</script>

<style lang="stylus" scoped>
  #tittle
    color: #43ADE1
  .button
    border: none
    color: white
    border-radius: 6px
    height: 50px;
  #buttonSave
    background: #43ADE1
  #buttonSave:hover
    background: #2D9CD3
  #buttonBack
    background: #A6B5BD
  #buttonBack:hover
    background: #81888C
</style>
